import { render, staticRenderFns } from "./ThreeColumnText.vue?vue&type=template&id=17064386&scoped=true&"
import script from "./ThreeColumnText.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnText.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnText.vue?vue&type=style&index=0&id=17064386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17064386",
  null
  
)

export default component.exports